export default function () {
  return this.rotated ? this.internalImageHeight : this.internalImageWidth
}
